export default __webpack_public_path__ + "static/media/Leggings of Wild Furor.eca8ef9f.jpg";